/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AuthorityType } from './authority-type';


export interface UserCompactDTO { 
    id?: string;
    email?: string;
    nome?: string;
    cognome?: string;
    authorities?: Set<AuthorityType>;
}

